import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App";
import { EmailGuard } from "../App";
import { toast } from "react-toastify";
import { StandardURL } from "../App";


const PropertyKYCPage = () => {
  const [propertyKycDataList, setPropertyKycDataList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPropertyKycData();
  }, []);

  const fetchPropertyKycData = async () => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${StandardURL}/iNyumba/propertykyc/fetchall`,
        config
      );
      setPropertyKycDataList(response.data.response);
    } catch (error) {
      console.error("Error fetching property KYC data:", error);
    }
  };

  const handleUpdate = async (propertyId) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Perform update logic here

      // Example update request
      await axios.patch(
        `${StandardURL}/iNyumba/propertykyc/update/${propertyId}`,
        {},
        config
      );

      toast.success("Updated succesfully");
      // Refresh property KYC data after update
      fetchPropertyKycData();
    } catch (error) {
      console.error("Error updating property KYC data:", error);
      toast.error("Error updating property KYC data");
    }
  };

  const handleDelete = async (propertyId) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Example delete request
      const response = await axios.delete(
        `${StandardURL}/iNyumba/propertykyc/delete/${propertyId}`,
        config
      );

      toast.success(response.data.response);

      // Refresh property KYC data after deletion
      fetchPropertyKycData();
    } catch (error) {
      toast.error(error.response.data.response);
      console.error("Error deleting property KYC data:", error);
    }
  };

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto max-w-7xl rounded-2xl bg-white p-6 shadow-xl sm:p-8">
            <h1 className="mb-8 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Property KYC Verification
            </h1>
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto border-collapse">
                <thead>
                  <tr className="bg-sky-50 text-left text-xs font-semibold uppercase tracking-wider text-gray-600">
                    <th className="px-6 py-4">Property ID</th>
                    <th className="px-6 py-4">Business PIN</th>
                    <th className="px-6 py-4">Reg. Certificate</th>
                    <th className="px-6 py-4">CR12 Certificate</th>
                    <th className="px-6 py-4">Utility Bills</th>
                    <th className="px-6 py-4">Business Permit</th>
                    <th className="px-6 py-4">Status</th>
                    <th className="px-6 py-4 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {propertyKycDataList.map((property, index) => (
                    <tr
                      key={property.property_id}
                      className="transition-colors duration-200 hover:bg-sky-50"
                    >
                      <td className="px-6 py-5 font-medium text-gray-900">
                        {property.property_id}
                      </td>
                      <td className="px-6 py-5">
                        <a
                          href={property.business_pin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                        >
                          View
                        </a>
                      </td>
                      <td className="px-6 py-5">
                        <a
                          href={property.reg_certificate}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                        >
                          View
                        </a>
                      </td>
                      <td className="px-6 py-5">
                        <a
                          href={property.cr12_certificate}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                        >
                          View
                        </a>
                      </td>
                      <td className="px-6 py-5">
                        <a
                          href={property.utility_bills}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                        >
                          View
                        </a>
                      </td>
                      <td className="px-6 py-5">
                        <a
                          href={property.business_permit}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800 hover:underline"
                        >
                          View
                        </a>
                      </td>
                      <td className="px-6 py-5">
                        <span
                          className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold uppercase ${
                            property.status === "Verified"
                              ? "bg-green-100 text-green-800"
                              : property.status === "Pending"
                                ? "bg-yellow-100 text-yellow-800"
                                : property.status === "Denied"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-gray-100 text-gray-800"
                          }`}
                        >
                          {property.status}
                        </span>
                      </td>
                      <td className="px-6 py-5 text-center">
                        <div className="flex justify-center space-x-2">
                          <button
                            onClick={() => handleUpdate(property.property_id)}
                            className="transform rounded-full bg-blue-600 px-4 py-2 text-xs font-medium text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-blue-700"
                          >
                            Update
                          </button>
                          <button
                            onClick={() => handleDelete(property.property_id)}
                            className="transform rounded-full bg-red-600 px-4 py-2 text-xs font-medium text-white shadow-sm transition-all duration-200 hover:scale-105 hover:bg-red-700"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};
export default PropertyKYCPage;
